import React from "react";
import PropTypes from "prop-types";

export default class Input extends React.Component {
    constructor(props) {
        super(props);

        this.onChange = this.onChange.bind(this);
    }

    onChange(option) {
        this.props.onChange(option);
    }

    render() {
        const {props: {label, type, options, values, name}} = this;

        return <fieldset>
            {label && <legend className={'title'}>
                {label}
            </legend>}
            {options && options.map(option => <>
                <div>{type === 'checkbox' && <input id={`${name}-${option.value}`}
                                               checked={(values && values.indexOf(option.value) > -1) ? true : false}
                                               type={type}
                                               value={option.value} onChange={event => this.onChange(option)}/>}
                <label htmlFor={`${name}-${option.value}`} key={`filter-value-${option.value}`}>
                    <span dangerouslySetInnerHTML={{__html: option.label}}/>
                </label> </div>
            </>)}
        </fieldset>;
    }
}

Input.propTypes = {
    name: PropTypes.string,
    options: PropTypes.array.isRequired,
    values: PropTypes.array,
    label: PropTypes.string,
    type: PropTypes.string,
    onClick: PropTypes.func
};

Input.defaultProps = {
    name: '',
    values: [],
    label: '',
    type: 'checkbox',
    onChange: (value) => {
        console.log(value)
    }
}